<script setup>
import { ref } from 'vue';
import AppMenuItem from './AppMenuItem.vue';
import ShortLinkCreate from '../views/ShortLink.vue';
import PageCreate from '../views/Page.vue';
import WebformCreate from '../views/Webform.vue';
import BulkCreate from '../views/Bulk.vue';
import ExtensionsDialog from '../views/Extensions.vue';
import SupportDialog from '../views/Support.vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const separator = ref(false);

const drawerVisibleShortlink = ref(false);

function openDrawerShortlink() {
  drawerVisibleShortlink.value = true;
}

function updateDrawerVisibilityShortlink(value) {
  drawerVisibleShortlink.value = value;
}

const drawerVisiblePage = ref(false);

function openDrawerPage() {
  drawerVisiblePage.value = true;
}

function updateDrawerVisibilityPage(value) {
  drawerVisiblePage.value = value;
}

const drawerVisibleWebform = ref(false);

function openDrawerWebform() {
  drawerVisibleWebform.value = true;
}

function updateDrawerVisibilityWebform(value) {
  drawerVisibleWebform.value = value;
}

const drawerVisibleBulk = ref(false);

function openDrawerBulk() {
  drawerVisibleBulk.value = true;
}

function updateDrawerVisibilityBulk(value) {
  drawerVisibleBulk.value = value;
}

const dialogVisibleExtensions = ref(false);

function openDialogExtenions() {
  dialogVisibleExtensions.value = true;
}

function dialogVisibilityExtensions(value) {
  dialogVisibleExtensions.value = value;
}

const dialogVisibleSupport = ref(false);

function openDialogSupport() {
  dialogVisibleSupport.value = true;
}

function dialogVisibilitySupport(value) {
  dialogVisibleSupport.value = value;
}

const model = ref([
  {
    items: [
      { separator: true },
      { label: 'menu.dashboard', icon: 'pi pi-fw pi-home', to: '/' },
      { separator: true },
      { label: 'menu.shortlinks', icon: 'pi pi-fw pi-link', to: '/shortlinks' },
      { label: 'menu.pages', icon: 'pi pi-fw pi-file', to: '/pages', class: 'rotated-icon' },
      { label: 'menu.webforms', icon: 'pi pi-fw pi-clipboard', to: '/webforms', class: 'rotated-icon', isNew: true },
      { separator: true }
    ],
  },
  {
    items: [
      { label: 'menu.domains', icon: 'pi pi-fw pi-globe', to: '/domains' },
      { label: 'menu.workspaces', icon: 'pi pi-fw pi-users', to: '/workspaces' },
      { label: 'menu.email_reports', icon: 'pi pi-fw pi-inbox', to: '/scheduled' },
    ],
  },
]);
const items = [
  {
    label: t('menu.shortlink'),
    icon: 'pi pi-link',
    command: () => {
      openDrawerShortlink();
    }
  },
  {
    separator: true
  },
  {
    label: t('menu.bulks'),
    icon: 'pi pi-file-import',
    command: () => {
      openDrawerBulk();
    }
  },
  {
    separator: true
  },
  {
    label: t('menu.page'),
    icon: 'pi pi-file',
    command: () => {
      openDrawerPage();
    },
  },
  {
    separator: true
  },
  {
    label: t('menu.webform'),
    icon: 'pi pi-clipboard',
    command: () => {
      openDrawerWebform();
    },
  }
];

const modelFooter = ref([
  {
    items: [
      {
        label: t('menu.extensions'), icon: 'pi pi-fw pi-compass', command: () => {
          openDialogExtenions();
        },
      },
      {
        separator: true
      },
      {
        label: t('menu.support'), icon: 'pi pi-fw pi-question', command: () => {
          openDialogSupport();
        },
      }
    ],
  },
]);

</script>

<template>
  <ul class="layout-menu">
    <ShortLinkCreate :visible="drawerVisibleShortlink" @update:visible="updateDrawerVisibilityShortlink" />
    <PageCreate :visible="drawerVisiblePage" @update:visible="updateDrawerVisibilityPage" />
    <WebformCreate :visible="drawerVisibleWebform" @update:visible="updateDrawerVisibilityWebform" />
    <BulkCreate :visible="drawerVisibleBulk" @update:visible="updateDrawerVisibilityBulk" />
    <ExtensionsDialog :visible="dialogVisibleExtensions" @update:visible="dialogVisibilityExtensions" />
    <SupportDialog :visible="dialogVisibleSupport" @update:visible="dialogVisibilitySupport" />

    <SplitButton pt:pcMenu:item:class="px-0.5 py-1" :fluid="true" dropdownIcon="pi pi-plus-circle" class="mb-5 mt-1"
      size="large" :label="t('common.labels.new')" @click="openDrawerShortlink" :model="items" />

    <div v-if=separator class="border-t-[0.1rem] mb-5 mt-5"></div>
    <template v-for="(item, i) in model" :key="item">
      <app-menu-item v-if="!item.separator" :item="item"></app-menu-item>
    </template>
  </ul>
  <ul class="layout-menu">
    <template v-for="(item, i) in modelFooter" :key="item">
      <app-menu-item v-if="!item.separator" :item="item"></app-menu-item>
    </template>
  </ul>
</template>
